module.exports = __webpack_public_path__ + "img/img2.36e1f393.jpg";